import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=99cdf300"
import script from "./privacyPolicy.vue?vue&type=script&lang=ts"
export * from "./privacyPolicy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports